import config from '../../config'

const { uploadService } = config

export interface UploadResponse {
  result: boolean
  fileUrl: string
}

export async function uploadPhotoFile(file: File, token?: string): Promise<string> {
  try {
    const formData = new FormData()
    formData.append('fileName', file)
    formData.append('project', 'cms')
    formData.append('deviceType', 'WEBSITE')

    const isProduction = window.location.hostname === 'my.haupcar.com'
    const staticToken = isProduction
      ? 'HAUPeyJhbGciOiJub25lIiwidHlwIjoiSldUIn0.eyJ1c2VybmFtZSI6InVwbG9hZHNlcnZpY2Vwcm9kQGhhdXBjYXIuY29tIiwidG9rZW5kYXRlIjoiL0RhdGUoMTc2MDM0MDEyMTAwMCkvIiwiaWF0IjoxNzYwMzQwMTIxfQ.'
      : 'HAUPeyJhbGciOiJub25lIiwidHlwIjoiSldUIn0.eyJ1c2VybmFtZSI6InRlc3Q1NTVAZXhhbWVwbGMub20iLCJ0b2tlbmRhdGUiOiIvRGF0ZSgxNzYxNTM3MTU0MDAwKS8iLCJpYXQiOjE3NjE1MzcxNTR9.'

    const headers: HeadersInit = {
      Authorization: staticToken,
    }

    const response = await fetch(`${uploadService.URL}/upload`, {
      method: 'POST',
      headers,
      body: formData,
    })

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.statusText}`)
    }

    const result: UploadResponse = await response.json()

    if (result.result && result.fileUrl) {
      return result.fileUrl
    } else {
      throw new Error('Upload failed: Invalid response')
    }
  } catch (error: any) {
    throw error?.message || error
  }
}
